import { createContext, useContext, useState, useEffect } from "react";
import AuthService from "../services/api";
import fireToast from "../helpers/toaster";

const DropdownContext = createContext();

/** Mantine Select rejects duplicate option values; API may return duplicates. */
function dedupeOptionsArray(options) {
  if (!Array.isArray(options) || options.length === 0) return options;
  const first = options[0];
  if (typeof first === "string") {
    const seen = new Set();
    return options.filter((v) => {
      if (seen.has(v)) return false;
      seen.add(v);
      return true;
    });
  }
  if (typeof first !== "object" || first === null || !("value" in first)) {
    return options;
  }
  const seen = new Set();
  return options.filter((opt) => {
    if (seen.has(opt.value)) return false;
    seen.add(opt.value);
    return true;
  });
}

function dedupeDropdownNested(data) {
  if (data === null || data === undefined) return data;
  if (Array.isArray(data)) {
    return data.map(dedupeDropdownNested);
  }
  if (typeof data !== "object") return data;
  const out = {};
  for (const key of Object.keys(data)) {
    const val = data[key];
    if (key === "options" && Array.isArray(val)) {
      out[key] = dedupeOptionsArray(val);
    } else if (val && typeof val === "object") {
      out[key] = dedupeDropdownNested(val);
    } else {
      out[key] = val;
    }
  }
  return out;
}

export const DropdownProvider = ({ children }) => {
  const [dropdownValues, setDropdownValues] = useState(null);

  useEffect(() => {
    AuthService.getArrayByKey("all")
      .then((response) => {
        setDropdownValues(dedupeDropdownNested(response.data.data));
      })
      .catch((error) => {
        if (error.response) {
          fireToast("error", error.response.data.message, "bottom-right", true);
        }
      });
  }, []);

  return (
    <DropdownContext.Provider value={{ dropdownValues }}>
      {children}
    </DropdownContext.Provider>
  );
};

export const useDropdownValues = () => useContext(DropdownContext);
